import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";

const ALL_LINKS = [
  { label: "Rottebekæmpelse", to: "/ydelser/rottebekaempelse" },
  { label: "Serviceaftale", to: "/ydelser/serviceaftale" },
  { label: "No-dig", to: "/ydelser/no-dig" },
  { label: "Spul & Rens", to: "/ydelser/spul-rens" },
];

export const Kloak = () => (
  <>
    <SEO
      title="Kloakopgaver – Autoriseret kloakmester i Nordsjælland"
      description="Autoriseret kloakmester: akut afløb, rørskader, renoveringer og større kloakprojekter. TV-inspektion, kvalitetssikring og dokumentation af alt udført arbejde."
    />
    <ServicePageTemplate
    eyebrow="Kloakopgaver"
    title={<>Fra akut afløb til <em className="text-[color:var(--fk-gold)]">større kloakarbejde.</em></>}
    subtitle="Som autoriseret kloakmester løser vi både akutte problemer, planlagte renoveringer og større anlægsopgaver. Vi arbejder med præcision, dokumenterer undervejs og sørger for, at løsningen bliver udført korrekt fra start."
    heroImage={ASSETS.images.pipes}
    intro="Uanset om opgaven handler om et stoppet afløb, en rørskade eller et større kloakprojekt, møder vi den med samme tilgang: Vi finder årsagen, lægger en plan og udfører arbejdet ordentligt."
    bullets={[
      "Etablering, reparation og renovering af kloak",
      "Håndtering af akutte skader og stoppede afløb",
      "TV-inspektion, fejlfinding og dokumentation",
      "Autoriseret kloakarbejde med lovpligtig kvalitetssikring",
    ]}
    process={[
      { title: "Besigtigelse", body: "Vi gennemgår opgaven på stedet, vurderer forholdene og giver et klart oplæg til næste skridt." },
      { title: "Plan", body: "Vi planlægger udførelsen, tidsplanen og eventuelle midlertidige løsninger, så arbejdet kan gennemføres ordentligt." },
      { title: "Udførelse", body: "Vi løser opgaven med fokus på faglighed, fremdrift og mindst mulig gene for dem, der bruger ejendommen." },
      { title: "KS & aflevering", body: "Vi afslutter med kvalitetssikring, dokumentation og en tydelig aflevering af det udførte arbejde." },
    ]}
    ctaHeading="Skal vi se på din kloakopgave?"
    ctaBody="Ring til døgnvagten ved akutte problemer, eller book en tid, hvis opgaven kræver besigtigelse, planlægning eller tilbud."
    related={ALL_LINKS}
  />
  </>
);
